import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsStopIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.76 18.2V5.72H18.24V18.2H5.76ZM7.6 16.36H16.4V7.56H7.6V16.36Z" />
    </SvgIcon>
  );
});
